import { useState, useEffect } from "react";
import { Link } from "react-router-dom";


export default function NotFound() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setTimeout(() => setLoaded(true), 100);
  }, []);

  return (
    <div style={styles.root}>
      {/* Stadium background layers */}
      <div style={styles.bgBase} />
      <div style={styles.bgGradient} />
      <div style={styles.bgVignette} />

      {/* Hero content */}
      <main style={styles.main}>
        <div style={styles.contentWrap}>
          {/* Left text */}
          <div
            style={{
              ...styles.textBlock,
              opacity: loaded ? 1 : 0,
              transform: loaded ? "translateY(0)" : "translateY(30px)",
              transition: "opacity 0.7s ease, transform 0.7s ease",
            }}
          >
            <div style={styles.errorCode}>404</div>
            <h1 style={styles.heading}>Page Not Found</h1>
            <p style={styles.subtext}>
              The page you are looking for no longer exists. Perhaps you can
              return back to the site's homepage and see if you can find what
              you are looking for.
            </p>
            <Link to="/" style={styles.ctaBtn}>
              Back To Homepage
            </Link>
          </div>

          {/* Right baseball */}
          <div
            style={{
              ...styles.ballWrap,
              opacity: loaded ? 1 : 0,
              transform: loaded ? "translateX(0) rotate(0deg)" : "translateX(60px) rotate(-15deg)",
              transition: "opacity 0.9s ease 0.2s, transform 0.9s cubic-bezier(.22,.68,0,1.2) 0.2s",
            }}
          >
            <BaseballSVG />
            <div style={styles.ballGlow} />
          </div>
        </div>
      </main>
    </div>
  );
}

function BaseballSVG() {
  return (
    <svg
      className="ball-float"
      viewBox="0 0 320 320"
      width="320"
      height="320"
      style={{ display: "block", filter: "drop-shadow(0 30px 60px rgba(0,0,0,0.6))" }}
    >
      <defs>
        <radialGradient id="ballGrad" cx="38%" cy="35%" r="65%">
          <stop offset="0%" stopColor="#f5f0e8" />
          <stop offset="60%" stopColor="#e8dcc8" />
          <stop offset="100%" stopColor="#c8b89a" />
        </radialGradient>
        <radialGradient id="ballShadow" cx="50%" cy="50%" r="50%">
          <stop offset="70%" stopColor="transparent" />
          <stop offset="100%" stopColor="rgba(0,0,0,0.25)" />
        </radialGradient>
      </defs>

      <circle cx="160" cy="160" r="148" fill="url(#ballGrad)" />
      <circle cx="160" cy="160" r="148" fill="url(#ballShadow)" />

      {/* Left seam */}
      <path
        d="M 95 60 C 60 100, 55 140, 65 160 C 55 180, 60 220, 95 260"
        stroke="#c8523a" strokeWidth="2.5" fill="none" strokeLinecap="round" opacity="0.7"
      />
      {/* Right seam */}
      <path
        d="M 225 60 C 260 100, 265 140, 255 160 C 265 180, 260 220, 225 260"
        stroke="#c8523a" strokeWidth="2.5" fill="none" strokeLinecap="round" opacity="0.7"
      />

      {/* Left stitches */}
      {[80,93,106,119,132,145,158,171,184,197,210,223,236].map((y, i) => (
        <g key={i}>
          <line x1="72" y1={y-5} x2="85" y2={y} stroke="#cc4433" strokeWidth="2" strokeLinecap="round"/>
          <line x1="72" y1={y+5} x2="85" y2={y} stroke="#cc4433" strokeWidth="2" strokeLinecap="round"/>
        </g>
      ))}

      {/* Right stitches */}
      {[80,93,106,119,132,145,158,171,184,197,210,223,236].map((y, i) => (
        <g key={i}>
          <line x1="248" y1={y-5} x2="235" y2={y} stroke="#cc4433" strokeWidth="2" strokeLinecap="round"/>
          <line x1="248" y1={y+5} x2="235" y2={y} stroke="#cc4433" strokeWidth="2" strokeLinecap="round"/>
        </g>
      ))}

      {/* Highlight */}
      <ellipse cx="125" cy="110" rx="28" ry="18" fill="white" opacity="0.18" transform="rotate(-30,125,110)" />
      <ellipse cx="118" cy="104" rx="10" ry="6" fill="white" opacity="0.22" transform="rotate(-30,118,104)" />

      {/* Rim shadow */}
      <circle cx="160" cy="160" r="148" fill="none" stroke="rgba(0,0,0,0.12)" strokeWidth="8" />
    </svg>
  );
}

const styles = {
  root: {
    fontFamily: "'Barlow', sans-serif",
    minHeight: "100vh",
    position: "relative",
    overflow: "hidden",
    background: "#0d0d0d",
  },
  bgBase: {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(160deg, #1a2a1a 0%, #0d1a0d 30%, #0a0a0a 60%, #1a0d05 100%)",
    zIndex: 0,
  },
  bgGradient: {
    position: "absolute",
    inset: 0,
    background: `
      radial-gradient(ellipse 80% 40% at 50% 70%, rgba(255,140,30,0.10) 0%, transparent 70%),
      radial-gradient(ellipse 60% 50% at 70% 60%, rgba(30,80,20,0.25) 0%, transparent 60%),
      radial-gradient(ellipse 100% 60% at 30% 80%, rgba(10,30,10,0.6) 0%, transparent 70%)
    `,
    zIndex: 1,
  },
  bgVignette: {
    position: "absolute",
    inset: 0,
    background: "radial-gradient(ellipse 120% 100% at 50% 0%, transparent 40%, rgba(0,0,0,0.85) 100%)",
    zIndex: 2,
  },
  main: {
    position: "relative",
    zIndex: 5,
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
  },
  contentWrap: {
    maxWidth: 1200,
    margin: "0 auto",
    padding: "60px 48px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 40,
  },
  textBlock: {
    flex: "0 0 auto",
    maxWidth: 520,
  },
  errorCode: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontWeight: 900,
    fontSize: "clamp(80px, 14vw, 140px)",
    color: "white",
    lineHeight: 1,
    letterSpacing: "-0.02em",
    textShadow: "0 4px 40px rgba(224,92,26,0.3)",
  },
  heading: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontWeight: 700,
    fontSize: "clamp(22px, 4vw, 34px)",
    color: "white",
    letterSpacing: "0.02em",
    textTransform: "uppercase",
    marginTop: 4,
    marginBottom: 18,
  },
  subtext: {
    fontFamily: "'Barlow', sans-serif",
    fontSize: 15,
    lineHeight: 1.65,
    color: "rgba(255,255,255,0.68)",
    maxWidth: 400,
    marginBottom: 36,
  },
  ctaBtn: {
    display: "inline-block",
    background: "#e05c1a",
    color: "white",
    fontFamily: "'Barlow Condensed', sans-serif",
    fontWeight: 700,
    fontSize: 14,
    letterSpacing: "0.10em",
    textTransform: "uppercase",
    padding: "13px 28px",
    borderRadius: 4,
    textDecoration: "none",
    transition: "background 0.2s, transform 0.2s, box-shadow 0.2s",
    cursor: "pointer",
    animation: "pulseCta 2.5s ease-in-out infinite",
  },
  ballWrap: {
    flex: "0 0 auto",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  ballGlow: {
    position: "absolute",
    bottom: -20,
    left: "50%",
    transform: "translateX(-50%)",
    width: 200,
    height: 30,
    background: "radial-gradient(ellipse, rgba(200,160,80,0.35) 0%, transparent 70%)",
    borderRadius: "50%",
    filter: "blur(8px)",
    pointerEvents: "none",
  },
};
